// Generated by CoffeeScript 2.7.0
require('./headimg.js');

require('./file_icon.js');
